export const getProductConfigurationOptionFallbackKey = ({ configId, optionIndex, property = "name" }) => {
	return `productConfiguration.${configId}.options[${optionIndex}].${property}`;
};

export const getProductConfigurationOptionTranslationKey = ({
	option,
	configId,
	optionIndex,
	property = "name",
	hasTranslation
}) => {
	const fallbackKey = getProductConfigurationOptionFallbackKey({
		configId,
		optionIndex,
		property
	});

	if (!(option && option.productId)) {
		return fallbackKey;
	}

	const productTranslationKey = `product.${option.productId}.name`;
	if (typeof hasTranslation === "function" && !hasTranslation(productTranslationKey)) {
		return fallbackKey;
	}

	return productTranslationKey;
};
